import React from 'react';
import Popup from 'reactjs-popup';
import themeImage from "../../../assets/images/Light-Canvas.jpg"

const ThemeVariationPopup = ({openModal, setOpen}) => {
  const closeModal = () => setOpen(false);
  return (
    <div>
      <Popup open={openModal} closeOnDocumentClick onClose={closeModal}>
        <div className="modal">
            <div className="modal-header">
                <h3>Theme variation list</h3>
            </div>
          <div className="modal-content">
          <div className="theme-wrapper">
            <div className="single-theme">
                <img src={themeImage}  alt="theme image" />
                <div className="theme-footer">
                    <button class="btn theme-active">Active</button>
                </div>
            </div>
            <div className="single-theme">
                <img src={themeImage}  alt="theme image" />
                <div className="theme-footer">
                    <button class="btn theme-active">Active</button>
                </div>
            </div>
            <div className="single-theme">
                <img src={themeImage}  alt="theme image" />
                <div className="theme-footer">
                    <button class="btn theme-active">Active</button>
                </div>
            </div>
            <div className="single-theme">
                <img src={themeImage}  alt="theme image" />
                <div className="theme-footer">
                    <button class="btn theme-active">Active</button>
                </div>
            </div>
            <div className="single-theme">
                <img src={themeImage}  alt="theme image" />
                <div className="theme-footer">
                    <button class="btn theme-active">Active</button>
                </div>
            </div>
        </div>
          </div>
        </div>
      </Popup>
    </div>
  );
};
export default ThemeVariationPopup;